import { Component, OnInit } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Locataire } from '../../../core/models/locataire.model';
import { LocataireService } from '../../../core/services/locataire.service';
import { APP_ROUTES } from '../../../core/constants/app-routes';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { SearchPipe } from '../../../core/pipes/search.pipe';
import { formatLogementChoiceLabel } from '../../../core/models/logement.model';

@Component({
  selector: 'app-liste-locataires',
  templateUrl: './liste-locataires.component.html',
  styleUrls: ['./liste-locataires.component.css'],
  imports: [RouterLink, FaIconComponent, FormsModule, SearchPipe, TranslateModule],
})
export class ListeLocatairesComponent implements OnInit {
  locataires: Locataire[] = [];
  query = '';
  loading = true;
  error = false;
  readonly routes = APP_ROUTES;

  constructor(
    private readonly locataireService: LocataireService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.locataireService.findAll().subscribe({
      next: (locataires) => {
        this.locataires = locataires ?? [];
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      },
    });
  }

  fullName(locataire: Locataire): string {
    return (
      `${locataire.prenomDto ?? ''} ${locataire.nomDto ?? ''}`.trim() ||
      this.translate.instant('locataires.sansNom')
    );
  }

  subtitle(locataire: Locataire): string {
    const phone = locataire.telephoneDto?.trim();
    if (phone) {
      return phone;
    }
    if (locataire.mailDto?.trim()) {
      return locataire.mailDto.trim();
    }
    return this.translate.instant('locataires.aucuneCoordonnee');
  }

  logementLabel(locataire: Locataire): string {
    const logement = locataire.logementDto;
    if (!logement) {
      return this.translate.instant('locataires.logementInconnu');
    }
    return formatLogementChoiceLabel(logement, (key) =>
      this.translate.instant(key)
    );
  }
}
